import * as THREE from 'three';

/** Stylized island turf: saturated greens + chalky paths (Fortnite-ish readability). */
export function createFloorTexture(size = 512): THREE.CanvasTexture {
  const c = document.createElement('canvas');
  c.width = c.height = size;
  const g = c.getContext('2d')!;
  g.fillStyle = '#3d6b45';
  g.fillRect(0, 0, size, size);
  const cell = 28;
  for (let y = 0; y < size; y += cell) {
    for (let x = 0; x < size; x += cell) {
      const v = ((x * 11 + y * 17) % 19) / 19;
      const warm = (x + y) % (cell * 3) < cell;
      if (warm) {
        g.fillStyle = `rgb(${58 + v * 28}, ${145 + v * 35}, ${72 + v * 22})`;
      } else {
        g.fillStyle = `rgb(${48 + v * 20}, ${120 + v * 30}, ${62 + v * 18})`;
      }
      g.fillRect(x + 1, y + 1, cell - 2, cell - 2);
    }
  }
  g.strokeStyle = 'rgba(0,0,0,0.22)';
  g.lineWidth = 1.5;
  for (let i = 0; i <= size; i += cell) {
    g.beginPath();
    g.moveTo(i, 0);
    g.lineTo(i, size);
    g.stroke();
    g.beginPath();
    g.moveTo(0, i);
    g.lineTo(size, i);
    g.stroke();
  }
  const tex = new THREE.CanvasTexture(c);
  tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
  tex.repeat.set(28, 28);
  tex.anisotropy = 8;
  tex.colorSpace = THREE.SRGBColorSpace;
  return tex;
}
